import * as z from "zod";
import { RepairFee, RepairInvoiceDetails } from "./get-repair-invoice-details";

export const createRepairInvoice = {
  name: "createRepairInvoice" as const,
  input: z.object({ returnId: z.string(), fees: z.array(RepairFee).min(1) }),
  output: RepairInvoiceDetails,
};
